import UserInfoSettingsComponent from "./UserInfoSettingsComponent";

export default UserInfoSettingsComponent;

